import React from 'react';
import AutocompleteTemplate from './templates/Autocomplete';
import DropdownTemplate from './templates/Dropdown';
import MultiAutocompleteTemplate from './templates/MultiAutocomplete';
import MultiDropdownTemplate from './templates/MultiDropdown';
const isAutocomplete = props => !!props.isAutocomplete && !props.isMultiple;
const isDropdown = props => !props.isAutocomplete && !props.isMultiple;
const isMultiAutocomplete = props => !!props.isAutocomplete && !!props.isMultiple;
const isMultiDropdown = props => !props.isAutocomplete && !!props.isMultiple;
const Dropdown = props => {
  if (isAutocomplete(props)) {
    return /*#__PURE__*/React.createElement(AutocompleteTemplate, props);
  }
  if (isDropdown(props)) {
    return /*#__PURE__*/React.createElement(DropdownTemplate, props);
  }
  if (isMultiAutocomplete(props)) {
    return /*#__PURE__*/React.createElement(MultiAutocompleteTemplate, props);
  }
  if (isMultiDropdown(props)) {
    return /*#__PURE__*/React.createElement(MultiDropdownTemplate, props);
  }
  return null;
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map